export let excess = [
  {
    full_date: '29-Dec-19 - 4-Jan-20',
    date: '2019-12-29',
    'epi-week': 1,
    prediction: 8855,
    lower: 8194,
    higher: 9516,
    excess_deaths: 8662,
  },
  {
    full_date: '5-Jan-20 - 11-Jan-20',
    date: '2020-01-05',
    'epi-week': 2,
    prediction: 8242,
    lower: 7581,
    higher: 8903,
    excess_deaths: 7895,
  },
  {
    full_date: '12-Jan-20 - 18-Jan-20',
    date: '2020-01-12',
    'epi-week': 3,
    prediction: 8092,
    lower: 7431,
    higher: 8753,
    excess_deaths: 7523,
  },
  {
    full_date: '19-Jan-20 - 25-Jan-20',
    date: '2020-01-19',
    'epi-week': 4,
    prediction: 7838,
    lower: 7177,
    higher: 8499,
    excess_deaths: 7454,
  },
  {
    full_date: '26-Jan-20 - 1-Feb-20',
    date: '2020-01-26',
    'epi-week': 5,
    prediction: 8013,
    lower: 7352,
    higher: 8674,
    excess_deaths: 8043,
  },
  {
    full_date: '2-Feb-20 - 8-Feb-20',
    date: '2020-02-02',
    'epi-week': 6,
    prediction: 8175,
    lower: 7514,
    higher: 8837,
    excess_deaths: 7819,
  },
  {
    full_date: '9-Feb-20 - 15-Feb-20',
    date: '2020-02-09',
    'epi-week': 7,
    prediction: 7956,
    lower: 7295,
    higher: 8617,
    excess_deaths: 8324,
  },
  {
    full_date: '16-Feb-20 - 22-Feb-20',
    date: '2020-02-16',
    'epi-week': 8,
    prediction: 7841,
    lower: 7180,
    higher: 8502,
    excess_deaths: 8360,
  },
  {
    full_date: '23-Feb-20 - 29-Feb-20',
    date: '2020-02-23',
    'epi-week': 9,
    prediction: 8053,
    lower: 7392,
    higher: 8714,
    excess_deaths: 8073,
  },
  {
    full_date: '1-Mar-20 - 7-Mar-20',
    date: '2020-03-01',
    'epi-week': 10,
    prediction: 8119,
    lower: 7458,
    higher: 8780,
    excess_deaths: 8584,
  },
  {
    full_date: '8 Mar-20 - 14-Jan-20',
    date: '2020-03-08',
    'epi-week': 11,
    prediction: 8021,
    lower: 7360,
    higher: 8682,
    excess_deaths: 8393,
  },
  {
    full_date: '15-Mar-20 - 21-Mar-20',
    date: '2020-03-15',
    'epi-week': 12,
    prediction: 7914,
    lower: 7253,
    higher: 8575,
    excess_deaths: 8180,
  },
  {
    full_date: '22-Mar-20 - 28-Mar-20',
    date: '2020-03-22',
    'epi-week': 13,
    prediction: 8174,
    lower: 7513,
    higher: 8835,
    excess_deaths: 8235,
  },
  {
    full_date: '29-Mar-20 - 4-Apr-20',
    date: '2020-03-29',
    'epi-week': 14,
    prediction: 8365,
    lower: 7704,
    higher: 9026,
    excess_deaths: 8239,
  },
  {
    full_date: '5-Apr-20 - 11-Apr-20',
    date: '2020-04-05',
    'epi-week': 15,
    prediction: 8263,
    lower: 7602,
    higher: 8925,
    excess_deaths: 8289,
  },
  {
    full_date: '12-Apr-20 - 18-Apr-20',
    date: '2020-04-12',
    'epi-week': 16,
    prediction: 8243,
    lower: 7582,
    higher: 8904,
    excess_deaths: 8122,
  },
  {
    full_date: '19-Apr-20 - 25-Apr-20',
    date: '2020-04-19',
    'epi-week': 17,
    prediction: 8362,
    lower: 7701,
    higher: 9023,
    excess_deaths: 7937,
  },
  {
    full_date: '26-Apr-20 - 2-May-20',
    date: '2020-04-26',
    'epi-week': 18,
    prediction: 8845,
    lower: 8184,
    higher: 9506,
    excess_deaths: 7999,
  },
  {
    full_date: '3-May-20 - 9-May-20',
    date: '2020-05-03',
    'epi-week': 19,
    prediction: 8904,
    lower: 8243,
    higher: 9565,
    excess_deaths: 8340,
  },
  {
    full_date: '10-May-20 - 16-May-20',
    date: '2020-05-10',
    'epi-week': 20,
    prediction: 8951,
    lower: 8290,
    higher: 9612,
    excess_deaths: 8475,
  },
  {
    full_date: '17-May-20 - 23-May-20',
    date: '2020-05-17',
    'epi-week': 21,
    prediction: 8719,
    lower: 8058,
    higher: 9380,
    excess_deaths: 8621,
  },
  {
    full_date: '24-May-20 - 30-May-20',
    date: '2020-05-24',
    'epi-week': 22,
    prediction: 9300,
    lower: 8639,
    higher: 9962,
    excess_deaths: 9170,
  },
  {
    full_date: '31-May-20 - 6-Jun-20',
    date: '2020-05-31',
    'epi-week': 23,
    prediction: 9923,
    lower: 9262,
    higher: 10584,
    excess_deaths: 9404,
  },
  {
    full_date: '7-Jun-20 - 13-Jun-20',
    date: '2020-06-07',
    'epi-week': 24,
    prediction: 10090,
    lower: 9429,
    higher: 10751,
    excess_deaths: 10019,
  },
  {
    full_date: '14-Jun-20 - 20-Jun-20',
    date: '2020-06-14',
    'epi-week': 25,
    prediction: 9943,
    lower: 9282,
    higher: 10604,
    excess_deaths: 11444,
  },
  {
    full_date: '21-Jun-20 - 27-Jun-20',
    date: '2020-06-21',
    'epi-week': 26,
    prediction: 9870,
    lower: 9209,
    higher: 10532,
    excess_deaths: 12012,
  },
  {
    full_date: '28-Jun-20 - 4-Jul-20',
    date: '2020-06-28',
    'epi-week': 27,
    prediction: 9945,
    lower: 9284,
    higher: 10606,
    excess_deaths: 12986,
  },
  {
    full_date: '5-Jul-20 - 11-Jul-20',
    date: '2020-07-05',
    'epi-week': 28,
    prediction: 9794,
    lower: 9133,
    higher: 10455,
    excess_deaths: 14295,
  },
  {
    full_date: '12-Jul-20 - 18-Jul-20',
    date: '2020-07-12',
    'epi-week': 29,
    prediction: 9580,
    lower: 8919,
    higher: 10241,
    excess_deaths: 15865,
  },
  {
    full_date: '19-Jul-20 - 25-Jul-20',
    date: '2020-07-19',
    'epi-week': 30,
    prediction: 9137,
    lower: 8476,
    higher: 9798,
    excess_deaths: 15764,
  },
  {
    full_date: '26-Jul-20 - 1-Aug-20',
    date: '2020-07-26',
    'epi-week': 31,
    prediction: 9386,
    lower: 8725,
    higher: 10047,
    excess_deaths: 14825,
  },
  {
    full_date: '2-Aug-20 - 8-Aug-20',
    date: '2020-08-02',
    'epi-week': 32,
    prediction: 9417,
    lower: 8756,
    higher: 10078,
    excess_deaths: 13317,
  },
  {
    full_date: '9-Aug-20 - 15-Aug-20',
    date: '2020-08-09',
    'epi-week': 33,
    prediction: 9284,
    lower: 8623,
    higher: 9945,
    excess_deaths: 11881,
  },
  {
    full_date: '16-Aug-20 - 22-Aug-20',
    date: '2020-08-16',
    'epi-week': 34,
    prediction: 9067,
    lower: 8406,
    higher: 9728,
    excess_deaths: 11335,
  },
  {
    full_date: '23-Aug-20 - 29-Aug-20',
    date: '2020-08-23',
    'epi-week': 35,
    prediction: 8906,
    lower: 8245,
    higher: 9568,
    excess_deaths: 10410,
  },
  {
    full_date: '30-Aug-20 - 5-Sep-20',
    date: '2020-08-30',
    'epi-week': 36,
    prediction: 9140,
    lower: 8479,
    higher: 9801,
    excess_deaths: 10185,
  },
  {
    full_date: '6-Sep-20 - 12-Sep-20',
    date: '2020-09-06',
    'epi-week': 37,
    prediction: 8857,
    lower: 8196,
    higher: 9519,
    excess_deaths: 9303,
  },
  {
    full_date: '13-Sep-20 - 19-Sep-20',
    date: '2020-09-13',
    'epi-week': 38,
    prediction: 8670,
    lower: 8009,
    higher: 9331,
    excess_deaths: 8956,
  },
  {
    full_date: '20-Sep-20 - 26-Sep-20',
    date: '2020-09-20',
    'epi-week': 39,
    prediction: 8469,
    lower: 7808,
    higher: 9130,
    excess_deaths: 9037,
  },
  {
    full_date: '27-Sep-20 - 3-Oct-20',
    date: '2020-09-27',
    'epi-week': 40,
    prediction: 8839,
    lower: 8178,
    higher: 9500,
    excess_deaths: 8855,
  },
  {
    full_date: '4-Oct-20 - 10-Oct-20',
    date: '2020-10-04',
    'epi-week': 41,
    prediction: 8532,
    lower: 7871,
    higher: 9193,
    excess_deaths: 9260,
  },
  {
    full_date: '11-Oct-20 - 17-Oct-20',
    date: '2020-10-11',
    'epi-week': 42,
    prediction: 8252,
    lower: 7591,
    higher: 8913,
    excess_deaths: 9413,
  },
  {
    full_date: '18-Oct-20 - 24-Oct-20',
    date: '2020-10-18',
    'epi-week': 43,
    prediction: 8211,
    lower: 7550,
    higher: 8872,
    excess_deaths: 9303,
  },
  {
    full_date: '25-Oct-20 - 31-Oct-20',
    date: '2020-10-25',
    'epi-week': 44,
    prediction: 8372,
    lower: 7711,
    higher: 9033,
    excess_deaths: 9166,
  },
  {
    full_date: '1-Nov-20 - 7-Nov-20',
    date: '2020-11-01',
    'epi-week': 45,
    prediction: 8283,
    lower: 7622,
    higher: 8944,
    excess_deaths: 9319,
  },
  {
    full_date: '8-Nov-20 - 14-Nov-20',
    date: '2020-11-08',
    'epi-week': 46,
    prediction: 8092,
    lower: 7430,
    higher: 8753,
    excess_deaths: 9748,
  },
  {
    full_date: '15-Nov-20 - 21-Nov-20',
    date: '2020-11-15',
    'epi-week': 47,
    prediction: 8001,
    lower: 7340,
    higher: 8662,
    excess_deaths: 9621,
  },
  {
    full_date: '22-Nov-20 - 28-Nov-20',
    date: '2020-11-22',
    'epi-week': 48,
    prediction: 8310,
    lower: 7649,
    higher: 8971,
    excess_deaths: 9456,
  },
  {
    full_date: '29-Nov-20 - 5-Dec-20',
    date: '2020-11-29',
    'epi-week': 49,
    prediction: 8439,
    lower: 7778,
    higher: 9100,
    excess_deaths: 10584,
  },
  {
    full_date: '6-Dec-20 - 12-Dec-20',
    date: '2020-12-06',
    'epi-week': 50,
    prediction: 8024,
    lower: 7363,
    higher: 8686,
    excess_deaths: 11564,
  },
  {
    full_date: '13-Dec-20 - 19-Dec-20',
    date: '2020-12-13',
    'epi-week': 51,
    prediction: 8368,
    lower: 7707,
    higher: 9029,
    excess_deaths: 12999,
  },
  {
    full_date: '20-Dec-20 - 26-Dec-20',
    date: '2020-12-20',
    'epi-week': 52,
    prediction: 8473,
    lower: 7812,
    higher: 9135,
    excess_deaths: 15905,
  },
  {
    full_date: '27-Dec-20 - 2-Jan-21',
    date: '2020-12-27',
    'epi-week': 53,
    prediction: 8552,
    lower: 7891,
    higher: 9214,
    excess_deaths: 19177,
  },
  {
    full_date: '3-Jan-21 - 9-Jan-21',
    date: '2021-01-03',
    'epi-week': 1,
    prediction: 8692,
    lower: 8031,
    higher: 9353,
    excess_deaths: 22761,
  },
  {
    full_date: '10-Jan-21 - 16-Jan-21',
    date: '2021-01-10',
    'epi-week': 2,
    prediction: 8092,
    lower: 7431,
    higher: 8753,
    excess_deaths: 24215,
  },
  {
    full_date: '17-Jan-21 - 23-Jan-21',
    date: '2021-01-17',
    'epi-week': 3,
    prediction: 7944,
    lower: 7283,
    higher: 8605,
    excess_deaths: 21066,
  },
  {
    full_date: '24-Jan-21 - 30-Jan-21',
    date: '2021-01-24',
    'epi-week': 4,
    prediction: 7694,
    lower: 7033,
    higher: 8355,
    excess_deaths: 15132,
  },
  {
    full_date: '31-Jan-21 - 6-Feb-21',
    date: '2021-01-31',
    'epi-week': 5,
    prediction: 7867,
    lower: 7206,
    higher: 8528,
    excess_deaths: 12771,
  },
  {
    full_date: '7-Feb-21 - 13-Feb-21',
    date: '2021-02-07',
    'epi-week': 6,
    prediction: 8026,
    lower: 7365,
    higher: 8687,
    excess_deaths: 11043,
  },
  {
    full_date: '14-Feb-21 - 20-Feb-21',
    date: '2021-02-14',
    'epi-week': 7,
    prediction: 7810,
    lower: 7148,
    higher: 8471,
    excess_deaths: 10438,
  },
  {
    full_date: '21-Feb-21 - 27-Feb-21',
    date: '2021-02-21',
    'epi-week': 8,
    prediction: 7698,
    lower: 7037,
    higher: 8359,
    excess_deaths: 9661,
  },
  {
    full_date: '28-Feb-21 - 6-Mar-21',
    date: '2021-02-28',
    'epi-week': 9,
    prediction: 7907,
    lower: 7246,
    higher: 8568,
    excess_deaths: 9636,
  },
  {
    full_date: '7-Mar-21 - 13-Mar-21',
    date: '2021-03-07',
    'epi-week': 10,
    prediction: 7972,
    lower: 7311,
    higher: 8633,
    excess_deaths: 9774,
  },
  {
    full_date: '14-Mar-21 - 20-Mar-21',
    date: '2021-03-14',
    'epi-week': 11,
    prediction: 7875,
    lower: 7214,
    higher: 8536,
    excess_deaths: 9041,
  },
  {
    full_date: '21-Mar-21 - 27-Mar-21',
    date: '2021-03-21',
    'epi-week': 12,
    prediction: 7771,
    lower: 7110,
    higher: 8432,
    excess_deaths: 9155,
  },
  {
    full_date: '28-Mar-21 - 3-Apr-21',
    date: '2021-03-28',
    'epi-week': 13,
    prediction: 8026,
    lower: 7365,
    higher: 8687,
    excess_deaths: 9261,
  },
  {
    full_date: '4-Apr-21 - 10-Apr-21',
    date: '2021-04-04',
    'epi-week': 14,
    prediction: 8215,
    lower: 7554,
    higher: 8876,
    excess_deaths: 9693,
  },
  {
    full_date: '11-Apr-21 - 17-Apr-21',
    date: '2021-04-11',
    'epi-week': 15,
    prediction: 8114,
    lower: 7453,
    higher: 8775,
    excess_deaths: 9695,
  },
  {
    full_date: '18-Apr-21 - 24-Apr-21',
    date: '2021-04-18',
    'epi-week': 16,
    prediction: 8094,
    lower: 7433,
    higher: 8755,
    excess_deaths: 9649,
  },
  {
    full_date: '25-Apr-21 - 1-May-21',
    date: '2021-04-25',
    'epi-week': 17,
    prediction: 8212,
    lower: 7551,
    higher: 8873,
    excess_deaths: 9724,
  },
  {
    full_date: '2-May-21 - 8-May-21',
    date: '2021-05-02',
    'epi-week': 18,
    prediction: 8686,
    lower: 8025,
    higher: 9348,
    excess_deaths: 10294,
  },
  {
    full_date: '9-May-21 - 15-May-21',
    date: '2021-05-09',
    'epi-week': 19,
    prediction: 8744,
    lower: 8083,
    higher: 9405,
    excess_deaths: 10619,
  },
  {
    full_date: '16-May-21 - 22-May-21',
    date: '2021-05-16',
    'epi-week': 20,
    prediction: 8791,
    lower: 8130,
    higher: 9452,
    excess_deaths: 10703,
  },
  {
    full_date: '23-May-21 - 29-May-21',
    date: '2021-05-23',
    'epi-week': 21,
    prediction: 8563,
    lower: 7902,
    higher: 9224,
    excess_deaths: 11129,
  },
  {
    full_date: '30-May-21 - 5-Jun-21',
    date: '2021-05-30',
    'epi-week': 22,
    prediction: 9136,
    lower: 8475,
    higher: 9797,
    excess_deaths: 12345,
  },
  {
    full_date: '6-Jun-21 - 12-Jun-21',
    date: '2021-06-06',
    'epi-week': 23,
    prediction: 9748,
    lower: 9087,
    higher: 10409,
    excess_deaths: 13066,
  },
  {
    full_date: '13-Jun-21 - 19-Jun-21',
    date: '2021-06-13',
    'epi-week': 24,
    prediction: 9911,
    lower: 9250,
    higher: 10572,
    excess_deaths: 12809,
  },
  {
    full_date: '20-Jun-21 - 26-Jun-21',
    date: '2021-06-20',
    'epi-week': 25,
    prediction: 9768,
    lower: 9107,
    higher: 10429,
    excess_deaths: 14659,
  },
  {
    full_date: '27-Jun-21 - 3-Jul-21',
    date: '2021-06-27',
    'epi-week': 26,
    prediction: 9697,
    lower: 9036,
    higher: 10358,
    excess_deaths: 16326,
  },
  {
    full_date: '4-Jul-21 - 10-Jul-21',
    date: '2021-07-04',
    'epi-week': 27,
    prediction: 9769,
    lower: 9108,
    higher: 10430,
    excess_deaths: 18030,
  },
  {
    full_date: '11-Jul-21 - 17-Jul-21',
    date: '2021-07-11',
    'epi-week': 28,
    prediction: 9620,
    lower: 8959,
    higher: 10281,
    excess_deaths: 19959,
  },
  {
    full_date: '18-Jul-21 - 24-Jul-21',
    date: '2021-07-18',
    'epi-week': 29,
    prediction: 9410,
    lower: 8749,
    higher: 10071,
    excess_deaths: 19551,
  },
  {
    full_date: '25-Jul-21 - 31-Jul-21',
    date: '2021-07-25',
    'epi-week': 30,
    prediction: 8974,
    lower: 8313,
    higher: 9635,
    excess_deaths: 17910,
  },
  {
    full_date: '1-Aug-21 - 7-Aug-21',
    date: '2021-08-01',
    'epi-week': 31,
    prediction: 9219,
    lower: 8558,
    higher: 9880,
    excess_deaths: 16096,
  },
  {
    full_date: '8-Aug-21 - 14-Aug-21',
    date: '2021-08-08',
    'epi-week': 32,
    prediction: 9250,
    lower: 8589,
    higher: 9911,
    excess_deaths: 14467,
  },
  {
    full_date: '15-Aug-21 - 21-Aug-21',
    date: '2021-08-15',
    'epi-week': 33,
    prediction: 9119,
    lower: 8458,
    higher: 9780,
    excess_deaths: 14638,
  },
  {
    full_date: '22-Aug-21 - 28-Aug-21',
    date: '2021-08-22',
    'epi-week': 34,
    prediction: 8905,
    lower: 8244,
    higher: 9566,
    excess_deaths: 13739,
  },
  {
    full_date: '29-Aug-21 - 4-Sep-21',
    date: '2021-08-29',
    'epi-week': 35,
    prediction: 8748,
    lower: 8087,
    higher: 9409,
    excess_deaths: 13381,
  },
  {
    full_date: '5-Sep-21 - 11-Sep-21',
    date: '2021-09-05',
    'epi-week': 36,
    prediction: 8978,
    lower: 8317,
    higher: 9639,
    excess_deaths: 12298,
  },
  {
    full_date: '12-Sep-21 - 18-Sep-21',
    date: '2021-09-12',
    'epi-week': 37,
    prediction: 8699,
    lower: 8038,
    higher: 9360,
    excess_deaths: 11009,
  },
  {
    full_date: '19-Sep-21 - 25-Sep-21',
    date: '2021-09-19',
    'epi-week': 38,
    prediction: 8515,
    lower: 7854,
    higher: 9176,
    excess_deaths: 10496,
  },
  {
    full_date: '26-Sep-21 - 2-Oct-21',
    date: '2021-09-26',
    'epi-week': 39,
    prediction: 8317,
    lower: 7656,
    higher: 8978,
    excess_deaths: 9863,
  },
  {
    full_date: '3-Oct-21 - 9-Oct-21',
    date: '2021-10-03',
    'epi-week': 40,
    prediction: 8680,
    lower: 8019,
    higher: 9341,
    excess_deaths: 9824,
  },
  {
    full_date: '10-Oct-21 - 16-Oct-21',
    date: '2021-10-10',
    'epi-week': 41,
    prediction: 8378,
    lower: 7717,
    higher: 9039,
    excess_deaths: 9806,
  },
  {
    full_date: '17-Oct-21 - 23-Oct-21',
    date: '2021-10-17',
    'epi-week': 42,
    prediction: 8104,
    lower: 7443,
    higher: 8765,
    excess_deaths: 9263,
  },
  {
    full_date: '24-Oct-21 - 30-Oct-21',
    date: '2021-10-24',
    'epi-week': 43,
    prediction: 8064,
    lower: 7403,
    higher: 8725,
    excess_deaths: 8862,
  },
  {
    full_date: '31-Oct-21 - 6-Nov-21',
    date: '2021-10-31',
    'epi-week': 44,
    prediction: 8221,
    lower: 7560,
    higher: 8882,
    excess_deaths: 9756,
  },
  {
    full_date: '7-Nov-21 - 13-Nov-21',
    date: '2021-11-07',
    'epi-week': 45,
    prediction: 8133,
    lower: 7472,
    higher: 8794,
    excess_deaths: 9677,
  },
  {
    full_date: '14-Nov-21 - 20-Nov-21',
    date: '2021-11-14',
    'epi-week': 46,
    prediction: 7944,
    lower: 7283,
    higher: 8605,
    excess_deaths: 9201,
  },
  {
    full_date: '21-Nov-21 - 27-Nov-21',
    date: '2021-11-21',
    'epi-week': 47,
    prediction: 7857,
    lower: 7196,
    higher: 8518,
    excess_deaths: 9058,
  },
  {
    full_date: '28-Nov-21 - 4-Dec-21',
    date: '2021-11-28',
    'epi-week': 48,
    prediction: 8161,
    lower: 7500,
    higher: 8822,
    excess_deaths: 10062,
  },
  {
    full_date: '5-Dec-21 - 11-Dec-21',
    date: '2021-12-05',
    'epi-week': 49,
    prediction: 8286,
    lower: 7625,
    higher: 8948,
    excess_deaths: 10012,
  },
  {
    full_date: '12-Dec-21 - 18-Dec-21',
    date: '2021-12-12',
    'epi-week': 50,
    prediction: 7880,
    lower: 7219,
    higher: 8541,
    excess_deaths: 11067,
  },
  {
    full_date: '19-Dec-21 - 25-Dec-21',
    date: '2021-12-19',
    'epi-week': 51,
    prediction: 8215,
    lower: 7554,
    higher: 8876,
    excess_deaths: 11775,
  },
  {
    full_date: '26-Dec-21 - 1-Jan-22',
    date: '2021-12-26',
    'epi-week': 52,
    prediction: 8320,
    lower: 7659,
    higher: 8981,
    excess_deaths: 11890,
  },
  {
    full_date: '02-Jan-22',
    date: '2022-01-02',
    'epi-week': 1,
    prediction: 8531,
    lower: 7864,
    higher: 9197,
    excess_deaths: 11268,
  },
  {
    full_date: '09-Jan-22',
    date: '2022-01-09',
    'epi-week': 2,
    prediction: 7942,
    lower: 7275,
    higher: 8608,
    excess_deaths: 10256,
  },
  {
    full_date: '16-Jan-22',
    date: '2022-01-16',
    'epi-week': 3,
    prediction: 7798,
    lower: 7131,
    higher: 8465,
    excess_deaths: 9283,
  },
  {
    full_date: '23-Jan-22',
    date: '2022-01-23',
    'epi-week': 4,
    prediction: 7555,
    lower: 6888,
    higher: 8222,
    excess_deaths: 8742,
  },
  {
    full_date: '30-Jan-22',
    date: '2022-01-30',
    'epi-week': 5,
    prediction: 7721,
    lower: 7054,
    higher: 8388,
    excess_deaths: 8958,
  },
  {
    full_date: '06-Feb-22',
    date: '2022-02-06',
    'epi-week': 6,
    prediction: 7877,
    lower: 7210,
    higher: 8543,
    excess_deaths: 8773,
  },
  {
    full_date: '13-Feb-22',
    date: '2022-02-13',
    'epi-week': 7,
    prediction: 7663,
    lower: 6996,
    higher: 8330,
    excess_deaths: 8486,
  },
  {
    full_date: '20-Feb-22',
    date: '2022-02-20',
    'epi-week': 8,
    prediction: 7553,
    lower: 6887,
    higher: 8220,
    excess_deaths: 8490,
  },
  {
    full_date: '27-Feb-22',
    date: '2022-02-27',
    'epi-week': 9,
    prediction: 7762,
    lower: 7095,
    higher: 8428,
    excess_deaths: 8614,
  },
  {
    full_date: '06-Mar-22',
    date: '2022-03-06',
    'epi-week': 10,
    prediction: 7826,
    lower: 7160,
    higher: 8493,
    excess_deaths: 8948,
  },
]
